<template>
  <main-content>
    <b-card>
      <ERegistrationPublicRegisterForm />
    </b-card>
  </main-content>
</template>

<script>
import ERegistrationPublicRegisterForm from "../components/e-registration-public-register/ERegistrationPublicRegisterForm";

export default {
  components: {
    ERegistrationPublicRegisterForm
  }
};
</script>

<style lang="scss" scoped></style>
